const modals = document.querySelectorAll('.video-modal');

modals.forEach(modal => {
    const openModalButton = modal.nextElementSibling;
    const video = modal.getElementsByTagName('video-component');

    openModalButton.addEventListener('click', function onOpen() {
        // .showModal() is part of the HTMLDialogElement API
        modal.showModal();
        // .play() is part of the HTMLMediaElement API
        video.play();
      });

      modal.addEventListener('close', function onClose() {
        // "Close" button inside the form triggers "close" on dialog because of [method="dialog"]
        // .pause() is part of the HTMLMediaElement API
        video.stop();
      });
});